export interface Solution {
  key: string;
  title: string;
  icon: string;
  summary: string;
  problem: string;
  approach: string;
  benefits: string[];
}

export const solutions: Solution[] = [
  {
    key: "2w",
    title: "2-Wheeler Retrofit",
    icon: "ri-motorbike-line",
    summary: "Electric conversion pathways for suitable two-wheelers already in use.",
    problem:
      "Two-wheelers are widely used for daily commuting, yet many remain dependent on petrol and reach the end of their useful life before their frame and cycle parts do.",
    approach:
      "Assessment of frame condition, weight distribution and usage pattern, followed by a retrofit configuration engineered around the specific vehicle.",
    benefits: [
      "Extends usable life of an existing vehicle",
      "Reduces dependence on fossil fuel for daily trips",
      "Configuration decided after technical assessment",
    ],
  },
  {
    key: "3w",
    title: "3-Wheeler Retrofit",
    icon: "ri-e-bike-2-line",
    summary: "Retrofit thinking for three-wheelers used in local mobility and last-mile duty.",
    problem:
      "Three-wheelers often run high daily distances on fixed routes, where fuel cost and maintenance directly affect operator earnings.",
    approach:
      "Duty-cycle based assessment — daily distance, load, route conditions — informing powertrain and battery sizing options.",
    benefits: [
      "Suited to high-utilisation local mobility duty cycles",
      "Potential reduction in running cost compared with fuel",
      "Retrofit approach evaluated vehicle by vehicle",
    ],
  },
  {
    key: "4w",
    title: "4-Wheeler Retrofit",
    icon: "ri-car-line",
    summary: "Converting suitable passenger cars into electric mobility solutions.",
    problem:
      "Replacing a serviceable car is a significant cost, even when the vehicle body and structure remain sound.",
    approach:
      "Structural, space and weight assessment followed by retrofit engineering for the electric powertrain and battery system.",
    benefits: [
      "Uses an existing vehicle instead of replacing it",
      "Enables electric mobility without a full new purchase",
      "Final feasibility depends on vehicle condition and architecture",
    ],
  },
  {
    key: "commercial",
    title: "Commercial Vehicle Retrofit",
    icon: "ri-truck-line",
    summary: "Retrofit evaluation for commercial vehicles with defined operating routes.",
    problem:
      "Commercial vehicles consume significant fuel on predictable routes where electrification can be considered.",
    approach:
      "Route, payload and utilisation study to determine whether a retrofit configuration is technically suitable.",
    benefits: [
      "Assessed against real route and payload requirements",
      "Supports gradual electrification of operations",
      "Feasibility subject to engineering assessment",
    ],
  },
  {
    key: "fleet",
    title: "Fleet Retrofit",
    icon: "ri-roadster-line",
    summary: "Electrification planning for organisations operating multiple vehicles.",
    problem:
      "Fleet operators hesitate to replace entire fleets because the cost and operational disruption are high.",
    approach:
      "Fleet assessment, prioritisation of vehicles and phased retrofit planning based on routes and utilisation.",
    benefits: [
      "Phased approach instead of full fleet replacement",
      "Charging requirements reviewed alongside vehicles",
      "Plan tailored to fleet operations",
    ],
  },
  {
    key: "specialized",
    title: "Specialized Vehicle Retrofit",
    icon: "ri-tools-line",
    summary: "Retrofit consideration for special-duty and application-specific vehicles.",
    problem:
      "Some vehicles serve specialised duties where a standard replacement option may not be practical.",
    approach:
      "Custom feasibility study covering architecture, duty cycle and integration requirements.",
    benefits: [
      "Approach adapted to the specific application",
      "Engineering-led, case-by-case evaluation",
      "Details confirmed only after technical assessment",
    ],
  },
];